import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-report h-6 w-6",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><path d=\"M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697\"></path><path d=\"M18 14v4h4\"></path><path d=\"M18 11v-4a2 2 0 0 0 -2 -2h-2\"></path><rect x=\"8\" y=\"3\" width=\"6\" height=\"4\" rx=\"2\"></rect><circle cx=\"18\" cy=\"18\" r=\"4\"></circle><path d=\"M8 11h4\"></path><path d=\"M8 15h3\"></path>", 8)
const _hoisted_10 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_10))
}
export default render